import { useQuery } from 'convex/react';
import { api } from '../../../../convex/_generated/api'; // DEEP_IMPORT_JUSTIFIED: hooks in src/pages/insurance/claim-detail/ require four levels up to reach convex/_generated/
import type { Id } from '../../../../convex/_generated/dataModel'; // DEEP_IMPORT_JUSTIFIED: standard convex _generated import pattern

export function useClaimData(claimId: Id<'claims'> | undefined) {
  const claimData = useQuery(
    api.insurance.claims.get,
    claimId ? { claimId } : 'skip'
  );
  const assignments = useQuery(
    api.insurance.benefitAssignments.getByPolicy,
    claimData ? { policyId: claimData.policyId } : 'skip'
  );
  const firstPlanId = assignments?.[0]?.planId;
  const benefitItems = useQuery(
    api.insurance.benefitItems.listByPlan,
    firstPlanId ? { planId: firstPlanId } : 'skip'
  );
  const utilization = useQuery(
    api.insurance.benefitAssignments.getUtilization,
    claimData ? { policyId: claimData.policyId } : 'skip'
  );
  return { claimData, benefitItems, utilization };
}
